(function () {
  var CustomFilterRange = class extends HTMLElement {
    connectedCallback(event) {
      this.param = this.dataset.param;
      this.maxParam = this.dataset.maxParam || this.param;
      this.availableValues = [...(this.dataset.values ? this.dataset.values.split(",").map((value) => Number(value.trim())) : []), ...(this.dataset.maxValues ? this.dataset.maxValues.split(",").map((value) => Number(value.trim())) : [])].sort((a, b) => a - b).filter((value, index, self) => self.indexOf(value) === index);
      this.checkboxInputs = this.querySelectorAll(".custom-filter-range__min-checkbox");
      this.maxCheckboxInputs = this.querySelectorAll(".custom-filter-range__max-checkbox");
      this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
      this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
      this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
      this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");
      this.valuesInput = this.querySelector(".custom-filter-range__input");
      this.maxValuesInput = this.querySelector(".custom-filter-range__input_max");
      this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
      this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());
      this.textInputLowerBound.addEventListener("change", (event2) => {
        event2.target.value = Math.max(Math.min(parseInt(event2.target.value), parseInt(this.textInputHigherBound.value || event2.target.max) - 1), event2.target.min);
        this.rangeLowerBound.value = event2.target.value;
        this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max) * 100}%`);
        this.valuesInput.value = this.availableValues.filter((value) => Number(value) >= Number(this.textInputLowerBound.value) && Number(value) <= Number(this.textInputHigherBound.value)).join(",");
        this.valuesInput.dispatchEvent(new Event("change", { bubbles: true }));
      });
      this.textInputHigherBound.addEventListener("change", (event2) => {
        event2.target.value = Math.min(Math.max(parseInt(event2.target.value), parseInt(this.textInputLowerBound.value || event2.target.min) + 1), event2.target.max);
        this.rangeHigherBound.value = event2.target.value;
        this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max) * 100}%`);
        this.valuesInput.value = this.availableValues.filter((value) => Number(value) >= Number(this.textInputLowerBound.value) && Number(value) <= Number(this.textInputHigherBound.value)).join(",");
        this.valuesInput.dispatchEvent(new Event("change", { bubbles: true }));
      });
      this.rangeLowerBound.addEventListener("change", (event2) => {
        this.textInputLowerBound.value = event2.target.value;
        this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
        this.valuesInput.value = this.availableValues.filter((value) => Number(value) >= Number(this.textInputLowerBound.value) && Number(value) <= Number(this.textInputHigherBound.value)).join(",");
        this.valuesInput.dispatchEvent(new Event("change", { bubbles: true }));
      });
      this.rangeHigherBound.addEventListener("change", (event2) => {
        this.textInputHigherBound.value = event2.target.value;
        this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
        this.valuesInput.value = this.availableValues.filter((value) => Number(value) >= Number(this.textInputLowerBound.value) && Number(value) <= Number(this.textInputHigherBound.value)).join(",");
        this.valuesInput.dispatchEvent(new Event("change", { bubbles: true }));
      });
      this.rangeLowerBound.addEventListener("input", (event2) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event2.target.value = Math.min(parseInt(event2.target.value), parseInt(this.textInputHigherBound.value || event2.target.max) - 1);
        event2.target.parentElement.style.setProperty("--range-min", `${parseInt(event2.target.value) / parseInt(event2.target.max) * 100}%`);
        this.textInputLowerBound.value = event2.target.value;
        this.valuesInput.value = this.availableValues.filter((value) => Number(value) >= Number(this.textInputLowerBound.value) && Number(value) <= Number(this.textInputHigherBound.value)).join(",");
      });
      this.rangeHigherBound.addEventListener("input", (event2) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event2.target.value = Math.max(parseInt(event2.target.value), parseInt(this.textInputLowerBound.value || event2.target.min) + 1);
        event2.target.parentElement.style.setProperty("--range-max", `${parseInt(event2.target.value) / parseInt(event2.target.max) * 100}%`);
        this.textInputHigherBound.value = event2.target.value;
        this.valuesInput.value = this.availableValues.filter((value) => Number(value) >= Number(this.textInputLowerBound.value) && Number(value) <= Number(this.textInputHigherBound.value)).join(",");
      });
      this.valuesInput.addEventListener("change", (event2) => {
        var activeValues = event2.target.value.split(",");
        this.checkboxInputs.forEach((checkbox, index) => {
          checkbox.checked = activeValues.includes(checkbox.value);
          this.maxCheckboxInputs.forEach((maxCheckbox, index) => {
            maxCheckbox.checked = activeValues.includes(maxCheckbox.value);
          });
          if (index === this.checkboxInputs.length - 1) {
            checkbox.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      });
      if (this.maxValuesInput) {
        this.maxValuesInput.addEventListener("change", (event2) => {
          var activeValues = event2.target.value.split(",");
          this.checkboxInputs.forEach((checkbox, index) => {
            checkbox.checked = activeValues.includes(checkbox.value);
            this.maxCheckboxInputs.forEach((maxCheckbox, index) => {
              maxCheckbox.checked = activeValues.includes(maxCheckbox.value);
            });
            if (index === this.checkboxInputs.length - 1) {
              checkbox.dispatchEvent(new Event("change", { bubbles: true }));
            }
          });
        });
      }
    }
  };
  !!window.customElements.get("custom-filter-range") || window.customElements.define("custom-filter-range", CustomFilterRange);

  var RangeClear = class extends HTMLElement {
    constructor() {
      super();
      this.buttonBoundListener = this._clickAction.bind(this);
    }
    connectedCallback() {
      this.addEventListener("click", this.buttonBoundListener);
    }
    disconnectedCallback() {
      this.removeEventListener("click", this.buttonBoundListener);
    }
    _clickAction(event) {
      this.param = this.dataset.param;
      this.targetRange = document.querySelector(`custom-filter-range[data-param="${this.param}"]`);
      if (this.targetRange) {
        this.checkboxInputs = this.targetRange.querySelectorAll(".custom-filter-range__min-checkbox");
        this.maxCheckboxInputs = this.targetRange.querySelectorAll(".custom-filter-range__max-checkbox");
        for (let i = 0; i < this.checkboxInputs.length; i++) {
          this.checkboxInputs[i].checked = false;
          if (i === this.checkboxInputs.length - 1 && !this.maxCheckboxInputs.length) this.checkboxInputs[i].dispatchEvent(new Event("change", { bubbles: true }));
        }
        // this.checkboxInputs.forEach((checkbox, index) => {
        //   checkbox.checked = false;
        //   if (!this.maxCheckboxInputs.length && index === this.checkboxInputs.length - 1) {
        //     checkbox.dispatchEvent(new Event("change", { bubbles: true }));
        //   }
        // });
        for (let i = 0; i < this.maxCheckboxInputs.length; i++) {
          this.maxCheckboxInputs[i].checked = false;
          if (i === this.maxCheckboxInputs.length - 1) this.maxCheckboxInputs[i].dispatchEvent(new Event("change", { bubbles: true }));
        }
        // if (this.maxCheckboxInputs.length) {
        //   this.maxCheckboxInputs.forEach((maxCheckbox, index) => {
        //     maxCheckbox.checked = false;
        //     if (index === this.checkboxInputs.length - 1) {
        //       maxCheckbox.dispatchEvent(new Event("change", { bubbles: true }));
        //     }
        //   });
        // }
      }
    }
  }
  !!window.customElements.get("range-clear") || window.customElements.define("range-clear", RangeClear);
})()